import { Component, Input, OnChanges, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { SessionHandlerService } from 'src/app/views/login/commons/services/session-handler.service';
import { NavigationPaths } from '../../config/navigation-paths.enum';
import { UserStatusEnum } from '../../config/user-status.enum';
import { IUser } from '../../interfaces/user.interface';

@Component({
    selector: 'pda-user-avatar',
    templateUrl: './user-avatar.component.html',
    styleUrls: ['./user-avatar.component.scss']
})
export class UserAvatarComponent implements OnInit, OnDestroy {

    user: IUser;

    clicked = false;

    showEnrollment = false;

    subs = new Subscription();

    constructor(private router: Router, private session: SessionHandlerService) {}

    ngOnInit(): void {
      this.subs.add(this.session.user$.subscribe(user => {
        this.user = user;
        this.verifyUserStatus();
      }));
    }
    ngOnDestroy(): void {
      this.subs.unsubscribe();
    }

    toggle(): void {
        this.clicked = !this.clicked;
    }
    closeSession(): void {
      this.session.closeSession(false);
      this.router.navigate([NavigationPaths.HOME]).then(() => location.reload());
    }

    verifyUserStatus(): void {
      this.showEnrollment = this.session.hasPendingEnroll();
    }
}
